import React from "react";
import logo from "./img/LTH_NAME_LOGO.png";
import Testimonial from "./Testimonial";

import Portfolio from './Portfolio';
import About from './About';
import Team from './Team';
import Contact from './Contact';



function Home() {
  return (
    <div className="hero">
      <div className="container-fluid">
        <div className="row align-items-center">

          <div className="col-md-6">
            <h2>Creative & Innovative</h2>
            <h2>
              <span>IT Solutions Company</span>
            </h2>
            <p>
              We provide cutting-edge software development, web development, and IT solutions to help businesses grow in the digital world. Our expert team focuses on delivering high-quality, scalable, and user-friendly solutions tailored to your needs.
            </p>

            <a
              className="btn"
              href="#"
              target="_blank"
              rel="noreferrer"
            >
              Build your digital future with us.
            </a>
          </div>

          <div className="col-md-6 text-center">
            <img src={logo} alt="Hero" style={{'height':'70%','width':'70%'}}/>
          </div>

        </div>
      </div><br/>
    
      <About/><br/>
      <Portfolio/><br/>
      <Team/><br/>
      
    <Testimonial />


    <Contact/>

    </div>

  );
}

export default Home;